import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const TeacherProfile = () => {
  const [courses, setCourses] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token") === null) {
      navigate('/customError');
    }
  }, [navigate]);

  useEffect(() => {
    const fetchCourses = async () => {
      const token = localStorage.getItem("token");

      try {
        const response = await fetch("http://193.123.94.90/teacher-profile", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        const transformed = (data.courses || []).map((courseName, idx) => ({
          title: courseName,
          level: data.level?.[idx] || "Unknown",
          students: data.counts?.[idx] || 0,
          rating: data.rating?.[idx],
          resource: data.resources?.[idx] || "#",
        }));

        setCourses(transformed);
      } catch (err) {
        console.error("Failed to load courses", err);
        navigate('/customError');
      }
    };

    fetchCourses();
  }, [navigate]);

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const handleAddCourse = () => {
    navigate("/add-course");
  };

  const handleSignOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("selectedCourse");
    navigate("/");
  };

  return (
    <div className="position-relative min-vh-100" style={{ backgroundColor: '#ffeae9', cursor: 'url("/pencil-cursor.png"), auto' }}>

      <div
        style={{
          backgroundImage: 'url("/background.jpg")',
          backgroundSize: 'contain',
          backgroundRepeat: 'repeat',
          backgroundPosition: 'center',
          opacity: 0.06,
          position: 'absolute',
          inset: 0,
          zIndex: 0,
        }}
      ></div>

      <div className="position-relative z-1 container py-4">

        <div className="position-absolute top-0 start-0 m-3">
          <button className="btn btn-sm btn-outline-danger px-2 py-1" style={{ fontSize: '0.8rem' }} onClick={handleSignOut}>
            Sign Out
          </button>
        </div>

        <div className="position-absolute top-0 end-0 m-3 d-flex align-items-center gap-2">
          <Link to="/chatapp">
            <img src="/msg1.jpeg" alt="Chatapp" width="45" height="45" />
          </Link>
          <Link to="/chat">
            <img src="/chatlink-logo.png" alt="ChatLink" width="45" height="45" />
          </Link>
        </div>

        <div className="text-center mb-5">
          <h1 className="display-4">Your Courses</h1>
          <button className="btn btn-sm rounded-pill px-3" style={{ backgroundColor: '#f5b5b5', color: 'white' }} onClick={handleAddCourse}>
            + Add Course
          </button>
        </div>

        {/* Courses */}
        <div className="row g-4">
          {courses.length > 0 ? (
            courses.map((course, index) => (
              <div
                className="col-md-6 col-lg-4"
                key={index}
                onMouseEnter={() => toggleDropdown(index)}
                onMouseLeave={() => toggleDropdown(null)}
              >
                <div className="card shadow-sm rounded-4">
                  <div className="card-body">
                    <h5 className="card-title">{course.title}</h5>
                    <p className="card-text"><strong>Level:</strong> {course.level}</p>
                    <p className="card-text"><strong>Students:</strong> {course.students}</p>
                    <p className="card-text"><strong>Rating:</strong> {course.rating}</p>
                    <p className="card-text">
                      <strong>Resources:</strong>{" "}
                      {course.resource !== "#" ? (
                        <a href={course.resource} target="_blank" rel="noopener noreferrer">Link</a>
                      ) : (
                        "No Resources Provided"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted">No courses added yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeacherProfile;
